import React, { Component } from 'react';

export const Profile = ({title = null, icon = null, subtitle = null, className=""}) => {
    return (
        <div className={`Profile ${className}`}>
            <div className="Profile-inner">
                <div className="app-icon-container">
                    <div className="Profile-app-icon" style={{backgroundImage: `url(${ icon })`}}></div>
                </div>
                <div className="Profile-meta-container">
                    <div className="Profile-account-title">
                        { title }
                    </div>
                    <div className="Profile-app-name">
                        { subtitle }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile;